import(/* webpackMode: "eager" */ "/var/www/nextjs-green/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AboutPublicPage"] */ "/var/www/nextjs-green/src/components/about/AboutPublicPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/nextjs-green/src/components/platform/HubeeHomePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StartView"] */ "/var/www/nextjs-green/src/components/start/StartView.tsx");
